/**
 * @license Givaudan
 * @author Ayoub MHAMDI
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AccountRemovedComponent } from './components/account-removed/account-removed.component';

const routes: Routes = [
  {
    path: 'account-removed',
    component: AccountRemovedComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SharedRoutingModule {}
